<template>
  <v-card outlined>
    <v-container class="px-1 py-1" fluid>
      <v-card-title class="pt-2 pb-0">
        {{ $t('ELE0028') }}
      </v-card-title>
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-card-text>
          <v-row dense>
            <v-col cols="6">
              <PartCodeInput v-if="isEpson" v-model="searchCondition.partCd" />
              <SupplierPartInput v-else v-model="searchCondition.partCd" :supplierCd="''" isSearchByLoginCompany />
            </v-col>
            <v-col cols="6">
              <validation-provider v-slot="{ errors }" name="Lot No.">
                <TextFieldInput :label="$t('ELE0049')" v-model="searchCondition.lotNo" :error-messages="errors" />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row align-content="space-between">
            <v-col cols="12" md="10">
              <v-row>
                <v-col cols="3">
                  <validation-provider v-slot="{ errors }" name="Ref No.">
                    <TextFieldInput :label="$t('ELE0056')" v-model="searchCondition.refNo" :error-messages="errors" />
                  </validation-provider>
                </v-col>
                <v-col cols="9">
                  <v-row dense align-content="center">
                    <TextFieldInputWithDatePicker
                      :label="$t('ELE0138')"
                      v-model="searchCondition.inspDateFrom"
                      @input="onDateChanged"
                    />
                    <span class="px-4 py-2"> {{ $t('ELE0141') }} </span>
                    <TextFieldInputWithDatePicker
                      :label="$t('ELE0138')"
                      v-model="searchCondition.inspDateTo"
                      @input="onDateChanged"
                    />
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row dense align-content="center" justify="end" class="pt-1">
                <BtnSearch @click="onClickSearch" :disabled="invalid" />
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card outlined>
                <v-card-title class="pt-1 pb-0">
                  {{ $t('ELE0023') }}
                  <v-spacer />
                </v-card-title>
                <v-data-table :headers="headers" :items="inspectionBoxList" dense>
                  <template v-slot:[`item.action`]="{ item }">
                    <IconDelete @click="confirm(item)" />
                  </template>
                  <template v-slot:[`item.refNo`]="{ item }">
                    <a @click="onRefNoCLick(item)" @href.stop.prevent="" style="text-decoration: underline">
                      {{ item.refNo }}
                    </a>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </validation-observer>
    </v-container>
    <BoxInformationDialog v-if="dialog" :dialog.sync="dialog" :refNo="selectedRefNo" />
    <ConfirmDialog
      :dialog.sync="confirmDialog.flag"
      :confirmWord="confirmDialog.confirmWord"
      :btnLabel="confirmDialog.btnLabel"
      @cancel="cancel"
      @proceed="proceed"
    />
  </v-card>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import PartCodeInput from '@/components/atoms/select/PartCodeInput.vue'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput.vue'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker.vue'
import BtnSearch from '@/components/atoms/button/BtnSearch.vue'
import BoxInformationDialog from '@/components/organisms/terminal/dialog/BoxInformationDialog.vue'
import IconDelete from '@/components/atoms/icon/IconDelete.vue'
import moment from 'moment'
import ConfirmDialog from '@/components/organisms/common/dialog/ConfirmDialog.vue'
import SupplierPartInput from '@/components/atoms/select/SupplierPartInput'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'SearchInspBoxForm',
  mixins: [APIUtils, Message, Loading, DateUtils],
  components: {
    PartCodeInput,
    TextFieldInput,
    TextFieldInputWithDatePicker,
    BtnSearch,
    BoxInformationDialog,
    IconDelete,
    ConfirmDialog,
    ValidationObserver,
    ValidationProvider,
    SupplierPartInput,
  },
  data() {
    return {
      dialog: false,
      selectedRefNo: '',
      searchCondition: {
        partCd: '',
        lotNo: '',
        refNo: '',
        inspTimingCd: this.$store.getters.getIQCorOQC,
        inspDateFrom: moment().subtract(1, 'W').format('YYYY-MM-DD'),
        inspDateTo: moment(new Date()).format('YYYY-MM-DD'),
      },
      headers: [
        { text: '', align: 'center', divider: true, sortable: false, value: 'action' },
        { text: this.$t('ELE0056'), divider: true, value: 'refNo' },
        { text: this.$t('ELE0049'), divider: true, value: 'lotNo' },
        { text: this.$t('ELE0031'), divider: true, value: 'partCd' },
        { text: this.$t('ELE0032'), divider: true, value: 'partName' },
        { text: this.$t('ELE0174'), divider: true, align: 'end', value: 'qty' },
        { text: this.$t('ELE0175'), divider: true, align: 'end', value: 'inspQty' },
        { text: this.$t('ELE0176'), divider: true, align: 'end', value: 'aqlSampleQty' },
        { text: this.$t('ELE0138'), divider: true, align: 'end', value: 'inspDate' },
      ],
      inspectionBoxList: [],
      confirmDialog: {
        flag: false,
        confirmWord: '',
        btnLabel: '',
      },
      selectedItem: '',
    }
  },
  computed: {
    isEpson: {
      get() {
        let result = false
        if (this.$store.getters.isEpson) {
          result = true
        }
        return result
      },
    },
  },
  methods: {
    confirm(item) {
      this.selectedItem = item
      if (item) {
        this.confirmDialog.confirmWord = `${this.$t('MSG0013')} ${item.refNo} `
        this.confirmDialog.btnLabel = this.$t('ELE0036')
        this.confirmDialog.flag = true
      } else {
        this.setErrorMessage(this.$t('MSG0019', { p0: this.$t('ELE0186') }))
      }
    },
    async onClickSearch() {
      this.startLoading()
      try {
        if (moment(this.searchCondition.inspDateFrom).add(1, 'Y') <= moment(this.searchCondition.inspDateTo)) {
          this.setErrorMessage(this.$t('MSG0100'))
          return
        }

        const params = { ...this.searchCondition, userCompanyCd: this.isEpson ? '' : this.$store.getters.companyCd }
        const data = await API.get('/box/getInspBoxes', params)
        this.inspectionBoxList = data
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0164') })))
      } finally {
        this.stopLoading()
      }
    },
    async onDeleteItem() {
      this.startLoading()
      try {
        const body = {
          refNo: this.selectedItem.refNo,
          inspTimingCd: this.selectedItem.inspTimingCd,
        }
        const response = await API.post('/box/inspBoxes/delete', body)
        if (response) {
          this.setSuccessMessage(this.$t('MSG0014', { p0: this.$t('ELE0186') }))
          this.onClickSearch()
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0004', { p0: this.$t('ELE0186') })))
      } finally {
        this.stopLoading()
      }
    },
    onDateChanged() {
      // this.onClickSearch()
    },
    async onRefNoCLick(item) {
      this.selectedRefNo = item.refNo
      this.dialog = true
    },
    cancel() {
      this.confirmDialog.flag = false
    },
    proceed() {
      this.confirmDialog.flag = false
      this.onDeleteItem()
    },
  },
  mounted() {
    this.onClickSearch()
  },
}
</script>
